module.exports = __webpack_public_path__ + "static/about-figures-1-bd2445a885f356165798e703f0ff371e.png";